import { createSelector } from '@ngrx/store';

import { reportFeature } from '../reducer/report.reducer';

export const {
  selectReports,
  selectStatuses,
  selectIsLoading,
  selectIsRequesting,
  selectError,
  selectSurveyPerformance,
} = reportFeature;

export const selectResults = createSelector(
  selectSurveyPerformance,
  (s) => s.results,
);
export const selectBuyers = createSelector(
  selectSurveyPerformance,
  (s) => s.buyers,
);
export const selectIsLoadingResults = createSelector(
  selectSurveyPerformance,
  (s) => s.isLoadingResults,
);
export const selectIsLoadingBuyers = createSelector(
  selectSurveyPerformance,
  (s) => s.isLoadingBuyers,
);
export const selectSurveyPerformanceError = createSelector(
  selectSurveyPerformance,
  (s) => s.error,
);
